import { Checkbox } from '@any-ui-react/core';
import type { ReactNode } from 'react';

import { useTableSelectionCtx } from '@/common/components/shared/table/selection/TableSelectionContext';

export interface TableSelectionBarProps {
  aside: ReactNode;
  maxSelection: number;
  total: number;
  currentPageSelection: number;
  onToggleSelection: () => void;
  onToggleAllPages: () => void;
  allPagesSelectable?: boolean;
}

export function TableSelectionBar<T extends Record<string, unknown>>({
  aside,
  maxSelection,
  total,
  onToggleSelection,
  onToggleAllPages,
  currentPageSelection,
  allPagesSelectable = true,
}: TableSelectionBarProps) {
  const { selection } = useTableSelectionCtx<T>();
  const allChecked = currentPageSelection === maxSelection;
  const indeterminateState = currentPageSelection !== maxSelection;
  const count = selection?.allPages ? total : selection?.items.length;

  return (
    <td className="flex h-full flex-row items-center bg-gray-9">
      <div className="sticky left-0 flex flex-row items-center gap-x-4 whitespace-nowrap px-4">
        <Checkbox
          checked={allChecked || indeterminateState}
          indeterminate={indeterminateState}
          label={<span className="ml-1 w-full font-semibold text-white">{`Selected: ${count}`}</span>}
          onChange={onToggleSelection}
        />
        {allPagesSelectable && (
          <button type="button" className="text-white underline" onClick={onToggleAllPages}>
            {selection?.allPages ? 'Deselect All' : 'Select All Pages'}
          </button>
        )}
        {aside}
      </div>
    </td>
  );
}
